/**
 * Sends error notifications to the FE-bugs Slack channel in production environment
 */
export const notifySlackOfError = async (
    location: string,
    error: Error | unknown,
    details?: Record<string, any>
): Promise<void> => {
    // Only send notifications in production
    if (!['production', 'staging', 'prod-preview', 'staging-preview'].includes(process.env.REACT_APP_ENV || '')) {
        console.log('Slack notifications are only sent in production')
        return
    }

    try {
        // Format error properly to avoid [object Object]
        let errorMessage: string
        if (error instanceof Error) {
            errorMessage = error.message
        } else if (typeof error === 'object' && error !== null) {
            try {
                errorMessage = JSON.stringify(error, Object.getOwnPropertyNames(error))
            } catch (e) {
                errorMessage = 'Error object could not be stringified: ' + String(error)
            }
        } else {
            errorMessage = String(error)
        }

        // Send to the Cloudflare Worker endpoint
        const response = await fetch('https://worker1.mach.exchange/', {
            method: 'POST',
            mode: 'no-cors',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                location,
                error: errorMessage,
                details,
            }),
        })

        if (!response.ok) {
            throw new Error(`Failed to send notification: ${response.statusText}`)
        }
    } catch (slackError) {
        // Don't let Slack notification errors affect the application
        console.error('Failed to send Slack notification:', slackError)
    }
}
